import { AxiosPromise } from 'axios';
import * as ThumbnailsProvider from '../../providers/thumbnails/thumbnailsProvider';

const gameThumbnailsApiInstance = new ThumbnailsProvider.GamesApi();
const gamePassesApiInstance = new ThumbnailsProvider.GamePassesApi();

enum ReturnPolicy {
  PlaceHolder = 'PlaceHolder',
  AutoGenerated = 'AutoGenerated',
  ForceAutoGenerated = 'ForceAutoGenerated'
}

enum Size {
  Large = '150x150',
  Default = '50x50'
}

enum FileType {
  Png = 'Png'
}

const getIcons = (
  universeIds: Array<number>,
  returnPolicy?: ReturnPolicy,
  size?: Size,
  format?: number
): AxiosPromise<ThumbnailsProvider.ApiArrayResponseThumbnailResponse> => {
  return gameThumbnailsApiInstance.v1GamesIconsGet(universeIds, returnPolicy, size, format);
};

const getGamePassIcons = (
  gamePassIds: Array<number>,
  size?: '150x150',
  format?: number
): AxiosPromise<ThumbnailsProvider.ApiArrayResponseThumbnailResponse> => {
  return gamePassesApiInstance.v1GamePassesGet(gamePassIds, size, format);
};

export default {
  getIcons,
  getGamePassIcons,
  ReturnPolicy,
  Size,
  FileType
};
